import React, { useState } from 'react';
import { dodajMerenje } from '../utils/merenja';
import { useAuth } from '../hooks/useAuthContext';

export default function FormaMerenja({ onDodato }) {
  const { currentUser } = useAuth();
  const now = new Date();
  const localISO = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
    .toISOString().slice(0, 16);

  const [form, setForm] = useState({
    sistolni: '',
    dijastolni: '',
    puls: '',
    datumVreme: localISO,
    napomena: ''
  });
  const [loading, setLoading] = useState(false);
  const [uspeh, setUspeh] = useState(false);
  const [greska, setGreska] = useState('');

  function handleChange(e) {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setGreska('');

    const s = Number(form.sistolni);
    const d = Number(form.dijastolni);
    const p = Number(form.puls);

    if (s < 50 || s > 300) return setGreska('Sistolni pritisak mora biti između 50 i 300.');
    if (d < 30 || d > 200) return setGreska('Dijastolni pritisak mora biti između 30 i 200.');
    if (form.puls && (p < 30 || p > 250)) return setGreska('Puls mora biti između 30 i 250.');

    setLoading(true);
    try {
      await dodajMerenje(currentUser.uid, {
        sistolni: s,
        dijastolni: d,
        puls: form.puls ? p : null,
        datumVreme: form.datumVreme,
        napomena: form.napomena.trim()
      });
      setUspeh(true);
      setForm(prev => ({ ...prev, sistolni: '', dijastolni: '', puls: '', napomena: '' }));
      setTimeout(() => setUspeh(false), 3000);
      onDodato && onDodato();
    } catch (err) {
      setGreska('Greška pri čuvanju. Pokušajte ponovo.');
    }
    setLoading(false);
  }

  return (
    <div className="card">
      <h3 className="form-card-title">
        <span>📋</span> Novo merenje
      </h3>

      {greska && <div className="alert alert-error" style={{ marginBottom: 16 }}>{greska}</div>}
      {uspeh && <div className="alert alert-success" style={{ marginBottom: 16 }}>✓ Merenje uspešno sačuvano!</div>}

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
        <div className="form-row">
          <div className="form-group">
            <label>Sistolni (gornji)</label>
            <input
              type="number"
              name="sistolni"
              placeholder="npr. 120"
              value={form.sistolni}
              onChange={handleChange}
              min="50" max="300"
              required
            />
            <span className="input-hint">mmHg</span>
          </div>

          <div className="form-group">
            <label>Dijastolni (donji)</label>
            <input
              type="number"
              name="dijastolni"
              placeholder="npr. 80"
              value={form.dijastolni}
              onChange={handleChange}
              min="30" max="200"
              required
            />
            <span className="input-hint">mmHg</span>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Puls (opciono)</label>
            <input
              type="number"
              name="puls"
              placeholder="npr. 72"
              value={form.puls}
              onChange={handleChange}
              min="30" max="250"
            />
            <span className="input-hint">otkucaja/min</span>
          </div>

          <div className="form-group">
            <label>Datum i vreme</label>
            <input
              type="datetime-local"
              name="datumVreme"
              value={form.datumVreme}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label>Napomena (opciono)</label>
          <input
            type="text"
            name="napomena"
            placeholder="npr. nakon odmora, jutarnje merenje..."
            value={form.napomena}
            onChange={handleChange}
            maxLength={200}
          />
        </div>

        <button type="submit" className="btn btn-teal" disabled={loading} style={{ alignSelf: 'flex-start', padding: '12px 28px' }}>
          {loading ? 'Čuvanje...' : '💾 Sačuvaj merenje'}
        </button>
      </form>
    </div>
  );
}
